import React from 'react';
import { PhoneIcon } from 'lucide-react';
export function PricingQuestions() {
  return <section className="bg-brand-black px-4 py-24 text-center sm:px-6 lg:px-8" data-id="element-702" data-mp="kteya7tsjqxk">
      <h2 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl" data-id="element-703" data-mp="fuvbk57dib45">Still have questions?</h2>
      <p className="mt-4 text-lg text-brand-light" data-id="element-704" data-mp="aw0t54dbiokk">Talk to AdROI right now.</p>
      <a href="tel:17022134801" className="mt-8 inline-flex items-center gap-2.5 rounded-md bg-brand-red px-8 py-4 text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-red-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-705" data-mp="ay4upfnqvbho">
        <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-706" data-mp="3obztweblak9o" />
        (702) 213-4801
      </a>
      <p className="mt-6 text-sm text-brand-light" data-id="element-707" data-mp="3jaiw4roejdxb">
        or email{' '}
        <a href="mailto:Results@GetAdROI.com" className="font-medium text-white underline underline-offset-2 hover:text-brand-light" data-id="element-708" data-mp="3f9guk470ips6">
          Results@GetAdROI.com
        </a>
      </p>
    </section>;
}